import { CoreIcon } from '../core-icon';
import layerFillSVG from '../../assets/icons/layer-fill.svg';
import type { IconProps } from '../core-icon';

export const LayerFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={layerFillSVG} {...props} />;
};
